var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-module',_vm._b({staticClass:"zg-chips-list-section"},'zg-module',_vm.moduleProps,false),[_vm._t("sub-title",null,{"slot":"sub-title"}),_vm._v(" "),_c('zg-tips',{attrs:{"items":_vm.items,"size":_vm.size,"section":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }